import isEmpty from "lodash/isEmpty";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { parsePhoneNumber } from "awesome-phonenumber";
import { validatePassword, } from "@pangeacyber/react-mui-shared";
export var useBreakpoint = function (breakpoint) {
    var theme = useTheme();
    return useMediaQuery(theme.breakpoints.down(breakpoint));
};
export var abbreviateNumber = function (value, shortform) {
    if (shortform === void 0) { shortform = true; }
    return Intl.NumberFormat("en-US", {
        notation: shortform ? "compact" : undefined,
        maximumFractionDigits: 2,
    }).format(value);
};
export function formatBytes(bytes, decimals, shortform, size, useExplicit) {
    if (decimals === void 0) { decimals = 3; }
    if (shortform === void 0) { shortform = true; }
    if (size === void 0) { size = undefined; }
    if (useExplicit === void 0) { useExplicit = false; }
    if (!bytes)
        return "0 Bytes";
    var k = 1024;
    var byteSizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    var explicitByteSizes = ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB"];
    var sizes = useExplicit ? explicitByteSizes : byteSizes;
    var dm = decimals < 0 ? 0 : decimals;
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    if (size !== undefined) {
        var sizeIdx = sizes.findIndex(function (s) { return s === size; });
        if (sizeIdx >= 0) {
            i = sizeIdx;
        }
    }
    if (i >= sizes.length) {
        return "bytes";
    }
    else {
        return "".concat(abbreviateNumber(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), shortform), " ").concat(sizes[i]);
    }
}
export var parseErrorFromPangea = function (error) {
    var _a, _b, _c, _d, _e;
    var response = (_a = error.response) !== null && _a !== void 0 ? _a : {};
    if (!response) {
        return "".concat(error);
    }
    if (((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.status) || ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.summary)) {
        return "".concat((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.status, ": ").concat((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.summary);
    }
    return "".concat(error);
};
export function passwordGenerator(len) {
    var length = len ? len : 10;
    var string = "abcdefghijklmnopqrstuvwxyz"; //to upper
    var numeric = "0123456789";
    var punctuation = "!@#$%^&*()_+~`|}{[]:;?><,./-=";
    var password = "";
    var character = "";
    var crunch = true;
    while (password.length < length) {
        var entity1 = Math.ceil(string.length * Math.random() * Math.random());
        var entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
        var entity3 = Math.ceil(punctuation.length * Math.random() * Math.random());
        var hold = string.charAt(entity1);
        hold = password.length % 2 == 0 ? hold.toUpperCase() : hold;
        character += hold;
        character += numeric.charAt(entity2);
        character += punctuation.charAt(entity3);
        password = character;
    }
    password = password
        .split("")
        .sort(function () {
        return 0.5 - Math.random();
    })
        .join("");
    return password.substr(0, len);
}
export var checkPassword = function (value, passwordPolicy) {
    return isEmpty(validatePassword(value, passwordPolicy));
};
export var PHONE_REGEXP = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|(1|[0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
// remove non-digits and prepend +1 if missing
export var cleanPhoneNumber = function (value) {
    var numbers = value.replace(/\D/g, "");
    return numbers.startsWith("+1") ? numbers : "+1".concat(numbers);
};
export var validatePhoneNumber = function (value) {
    if (value === void 0) { value = ""; }
    var pn = parsePhoneNumber(value, { regionCode: "US" });
    return pn.valid;
};
export var formatPhoneNumber = function (value) {
    if (value === void 0) { value = ""; }
    var pn = parsePhoneNumber(value, { regionCode: "US" });
    return pn.valid ? pn.number.international : value;
};
